// src/pages/Convocations/components/ConvocationsList.jsx

import React from "react";

import {
  FaRedo,
  FaTimes,
} from "react-icons/fa";

import { EMPTY_STATE_CONTENT } from "../data/convocation.data";

import ConvocationCard from "./ConvocationCard";

import ConvocationsTable from "./ConvocationsTable";

function LoadingState() {
  return (
    <>
      <div
        className="
          grid grid-cols-1
          gap-4
          md:grid-cols-2
          xl:hidden
        "
      >
        {Array.from({
          length: 4,
        }).map((_, index) => (
          <div
            key={index}
            className="
              h-[390px]
              animate-pulse
              rounded-3xl
              border border-slate-200
              bg-white
              dark:border-slate-800
              dark:bg-slate-900
            "
          >
            <div
              className="
                h-32
                rounded-t-3xl
                bg-slate-100
                dark:bg-slate-800
              "
            />

            <div className="space-y-4 p-4">
              <div
                className="
                  h-16 rounded-2xl
                  bg-slate-100
                  dark:bg-slate-800
                "
              />

              <div
                className="
                  h-12 rounded-2xl
                  bg-slate-100
                  dark:bg-slate-800
                "
              />

              <div
                className="
                  h-20 rounded-2xl
                  bg-slate-100
                  dark:bg-slate-800
                "
              />
            </div>
          </div>
        ))}
      </div>

      <div
        className="
          hidden h-[420px]
          animate-pulse
          rounded-3xl
          border border-slate-200
          bg-white
          dark:border-slate-800
          dark:bg-slate-900
          xl:block
        "
      >
        <div
          className="
            h-14 rounded-t-3xl
            bg-slate-900
            dark:bg-slate-950
          "
        />

        <div className="space-y-3 p-5">
          {Array.from({
            length: 4,
          }).map((_, index) => (
            <div
              key={index}
              className="
                h-72 rounded-2xl
                bg-slate-100
                dark:bg-slate-800
              "
            />
          ))}
        </div>
      </div>
    </>
  );
}

function EmptyState({
  type,
  onReset,
  onRefresh,
}) {
  const content =
    EMPTY_STATE_CONTENT[type];

  const Icon = content.Icon;

  return (
    <section
      className="
        flex min-h-[350px]
        flex-col items-center
        justify-center
        rounded-3xl
        border border-dashed
        border-slate-300
        bg-white/80
        px-5 py-12
        text-center
        shadow-sm
        dark:border-slate-700
        dark:bg-slate-900/80
      "
    >
      <span
        className="
          flex h-20 w-20
          items-center justify-center
          rounded-3xl
          bg-blue-50
          text-3xl
          text-blue-700
          dark:bg-blue-950/40
          dark:text-blue-300
        "
      >
        <Icon />
      </span>

      <h2
        className="
          mt-5
          font-satoshi
          text-xl font-black
          text-slate-950
          dark:text-white
        "
      >
        {content.title}
      </h2>

      <p
        className="
          mt-2 max-w-lg
          text-sm font-medium
          leading-6
          text-slate-500
          dark:text-slate-400
        "
      >
        {content.description}
      </p>

      <div
        className="
          mt-6 flex w-full
          max-w-sm flex-col
          gap-2
          sm:flex-row
          sm:justify-center
        "
      >
        {type === "noResult" ? (
          <button
            type="button"
            onClick={onReset}
            className="
              inline-flex min-h-11
              items-center justify-center
              gap-2 rounded-xl
              bg-blue-700
              px-4
              text-sm font-black
              text-white
              transition
              hover:bg-blue-800
            "
          >
            <FaTimes />

            Réinitialiser
          </button>
        ) : null}

        {type !== "noActor" ? (
          <button
            type="button"
            onClick={onRefresh}
            className="
              inline-flex min-h-11
              items-center justify-center
              gap-2 rounded-xl
              border border-slate-200
              bg-white
              px-4
              text-sm font-black
              text-slate-700
              transition
              hover:bg-slate-50
              dark:border-slate-700
              dark:bg-slate-950
              dark:text-slate-200
              dark:hover:bg-slate-800
            "
          >
            <FaRedo />

            Actualiser
          </button>
        ) : null}
      </div>
    </section>
  );
}

export default function ConvocationsList({
  actors,
  allConvocations,
  convocations,
  loading,
  saving,
  onOpenEvent,
  onOpenText,
  onRespond,
  onReset,
  onRefresh,
}) {
  if (loading) {
    return <LoadingState />;
  }

  if (
    !Array.isArray(actors) ||
    actors.length === 0
  ) {
    return (
      <EmptyState
        type="noActor"
        onReset={onReset}
        onRefresh={onRefresh}
      />
    );
  }

  if (
    !Array.isArray(
      allConvocations,
    ) ||
    allConvocations.length === 0
  ) {
    return (
      <EmptyState
        type="noConvocation"
        onReset={onReset}
        onRefresh={onRefresh}
      />
    );
  }

  if (
    !Array.isArray(convocations) ||
    convocations.length === 0
  ) {
    return (
      <EmptyState
        type="noResult"
        onReset={onReset}
        onRefresh={onRefresh}
      />
    );
  }

  return (
    <section>
      <div
        className="
          grid grid-cols-1
          gap-4
          md:grid-cols-2
          xl:hidden
        "
      >
        {convocations.map(
          (convocation) => (
            <ConvocationCard
              key={convocation.id}
              convocation={
                convocation
              }
              saving={saving}
              onOpenEvent={
                onOpenEvent
              }
              onOpenText={
                onOpenText
              }
              onRespond={onRespond}
            />
          ),
        )}
      </div>

      <ConvocationsTable
        convocations={convocations}
        saving={saving}
        onOpenEvent={onOpenEvent}
        onOpenText={onOpenText}
        onRespond={onRespond}
      />
    </section>
  );
}